import React from 'react'
import { connect } from 'react-redux'
import Loading from './widgets/Loading'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'

import {
    GROUP_ADD,
} from '../constants/actionTypes'
import Nav from './widgets/Nav'
import Header from './widgets/Header'

import { Link } from 'react-router-dom'
import Util from '../util/util'
import ListErrors from './widgets/ListErrors'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

const Promise = global.Promise

const mapStateToProps = state => ({
    ...state.file,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
})

const mapDispatchToProps = dispatch => ({
    onSubmit: (payload) => {
        dispatch({ type: GROUP_ADD, payload })
    },
})

class GroupAdd extends React.Component {
    constructor() {
        super()
        this.state = {
            name: '',
        }
        this.updateState = field => ev => {
            const state = this.state
            const newState = Object.assign({}, state, { [field]: ev.target.value })
            this.setState(newState)
        }
        this.submitForm = () => ev => {
            ev.preventDefault()
            const name = this.state.name
            const payload = agent.Files.createGroup(name)
            this.props.onSubmit(payload)
        }
    }

    componentWillMount() {

    }
    componentWillReceiveProps(nextProps) {

    }
    componentWillUnmount() {
    }

    render() {
        const name = this.state.name
        return (
            <Translation>
                {
                    (t) => (
                        <div id="main">
                            <Nav selected={'groups'} currentUser={this.props.currentUser} />
                            <div id="content">
                                <Header />
                                <div id="content-clear">
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <Link className='header-link' to={`/groups`}><i className="fad fa-arrow-alt-square-left"></i></Link>
                                            <h2>{t('file.group_create_title')}</h2>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('file.label_name')}</label>
                                            <input type="text" placeholder="" value={name} onChange={this.updateState('name')} />
                                        </div>
                                        <div className="form-item">
                                            <button type="button" onClick={this.submitForm()} disabled={this.props.inProgress}>{this.props.inProgress ? t('file.create_group_button_progress') : t('file.create_group_button')} </button>
                                        </div>
                                        <ListErrors errors={this.props.errors} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Translation>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupAdd)
